const styles = {
  PieContainer: {
    margin: "50px",
  },

  Pie: {
    width: "800px",
  },
};

export default styles;
